import { DietaryRestrictionText } from '../../Model/UserNutritionProfile';
import {
  RecipeTag,
  RecipeSource,
} from '../../utils/meals';

const texts = {
  recipeSource: {
    [RecipeSource.PUBLIC]: 'Public',
    [RecipeSource.CUSTOM]: 'Custom',
  },
  protein: 'Protein',
  carbs: 'Carbs',
  fat: 'Fat',
  macroNutrient: '{nutrient}: {amount}g ({percentage}%)',
  caloriesUnit: 'kcal',
  recipeImageAlt: 'Recipe image',
  prepTime: '{preparationTime} mins',
  cookTime: '{cookingTime} mins',
  ingredients: '{count} ingredients',
  noAllergens: '-',
  moreAllergens: '+{amount} More',
  containsDislikedIngredients: 'Contains disliked ingredients',
  violatingIngredients: 'This recipe contains the following disliked ingredients: {ingredients}',
  toolbarPlaceholder: 'Search by recipe name',
  mealFilter: 'Meal time',
  restrictionFilter: 'Restrictions',
  recipeSourceFilter: 'Source',
  dietMacroRange: 'Diet/Macro Range',
  archive: 'Archive',
  unarchive: 'Unarchive',
  showArchivedCheckbox: 'Show Archived Recipes',
  archiveSelectedRecipes: 'Archive Selected Recipes',
  actionText: 'Are you sure you want to {action} {actionable} recipe(s)?',
  archiveWarning: `
    This will remove the recipe(s) from all your active meal plans. Current meal plan assignments will be unaffected.
  `,
  successfullyProcessed: 'Recipe(s) {action}d successfully',
  processingError: 'Error {action}ing recipe(s). {error}',
  buttons: {
    breakfast: '+ Breakfast',
    lunch: '+ Lunch',
    snack: '+ Snack',
    dinner: '+ Dinner',
  },
  headers: {
    name: 'Recipe Name',
    protein: 'Protein',
    carbs: 'Carbs',
    fat: 'Fat',
    prepTime: 'Prep Time',
    cookTime: 'Cook Time',
    tags: 'Suitable For',
    calories: 'Calories',
    allergens: 'Allergens',
    actions: 'Actions',
  },
  meal: {
    [RecipeTag.BREAKFAST]: 'Breakfast',
    [RecipeTag.LUNCH]: 'Lunch',
    [RecipeTag.DINNER]: 'Dinner',
    [RecipeTag.SNACK]: 'Snack',
  },
};

export const allergensFilterOptions = {
  '': 'Filter by',
  ...DietaryRestrictionText,
};

export default texts;
